// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-container[data-v-6c091500] {\n  padding: 4px 12px;\n  border-radius: var(--brand-surface-radius, 4px);\n  border: 1px solid var(--v-white-base);\n}\n.payment-container[data-v-6c091500]:hover {\n  border: 1px solid var(--v-gray_30-base);\n  background-color: var(--v-gray_10-base);\n}\n.border-right[data-v-6c091500] {\n  border-right: 1px solid var(--v-gray_50-base);\n}\n.border-bottom[data-v-6c091500] {\n  border-bottom: 1px solid var(--v-gray_50-base);\n}", ""]);
// Exports
module.exports = exports;
